module.exports = __webpack_public_path__ + "img/ltkfindsunder50-3x.fd1307a.jpg";